import React from 'react';
import { User, Mail, Calendar, Music, Heart, ListMusic, Edit } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const navigate = useNavigate();

  // Mock user data (will be replaced with real data from backend)
  const user = {
    name: 'Visitante',
    email: 'visitante@tuiglesia.app',
    joinedDate: 'Marzo 2024',
    isGuest: true
  };

  const stats = [
    { icon: Music, label: 'Canciones', value: '0', color: 'from-blue-500 to-cyan-500' },
    { icon: Heart, label: 'Favoritos', value: '0', color: 'from-pink-500 to-rose-500' },
    { icon: ListMusic, label: 'Playlists', value: '0', color: 'from-purple-500 to-indigo-500' }
  ];

  if (user.isGuest) {
    return (
      <div className="flex-1 overflow-y-auto pb-32 bg-gradient-to-br from-gray-50 via-white to-blue-50">
        <div className="p-8">
          {/* Guest Profile Card */}
          <div className="max-w-3xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
              <div className="w-32 h-32 mx-auto mb-6 rounded-full bg-gradient-to-r from-[#00CCFF] to-[#056A84] flex items-center justify-center shadow-2xl">
                <User size={64} className="text-white" strokeWidth={2} />
              </div>
              <h1 className="text-4xl font-black text-gray-900 mb-3">Modo Visitante</h1>
              <p className="text-gray-500 text-lg mb-8">
                Estás navegando como visitante. Crea una cuenta para guardar tus playlists favoritas.
              </p>

              <button
                onClick={() => navigate('/auth')}
                className="px-8 py-4 bg-gradient-to-r from-[#00CCFF] to-[#056A84] text-white font-bold rounded-xl hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-2xl"
              >
                Crear Cuenta Gratis
              </button>

              <div className="mt-8 pt-8 border-t border-gray-200">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Beneficios de crear una cuenta</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="p-4 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl">
                    <Music className="w-8 h-8 text-[#00CCFF] mx-auto mb-2" />
                    <p className="text-sm font-semibold text-gray-900">Guarda tus canciones favoritas</p>
                  </div>
                  <div className="p-4 bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl">
                    <ListMusic className="w-8 h-8 text-[#00CCFF] mx-auto mb-2" />
                    <p className="text-sm font-semibold text-gray-900">Crea playlists personalizadas</p>
                  </div>
                  <div className="p-4 bg-gradient-to-br from-cyan-50 to-blue-50 rounded-xl">
                    <Heart className="w-8 h-8 text-[#00CCFF] mx-auto mb-2" />
                    <p className="text-sm font-semibold text-gray-900">Sincroniza en todos tus dispositivos</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Logged in user profile
  return (
    <div className="flex-1 overflow-y-auto pb-32 bg-gradient-to-br from-gray-50 via-white to-blue-50">
      <div className="p-8">
        {/* Profile Header */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-[#00CCFF] via-[#00CCFF]/90 to-[#056A84] rounded-2xl shadow-2xl p-8 mb-8">
            <div className="flex items-center gap-6">
              <div className="w-32 h-32 rounded-full bg-white flex items-center justify-center shadow-2xl">
                <span className="text-5xl font-black text-[#00CCFF]">{user.name[0]}</span>
              </div>
              <div className="flex-1">
                <h1 className="text-4xl font-black text-white mb-2">{user.name}</h1>
                <p className="text-white/90 text-lg mb-4 flex items-center gap-2">
                  <Mail size={18} />
                  {user.email}
                </p>
                <p className="text-white/80 flex items-center gap-2">
                  <Calendar size={16} />
                  Miembro desde {user.joinedDate}
                </p>
              </div>
              <button className="px-6 py-3 bg-white text-[#00CCFF] font-bold rounded-xl hover:scale-105 transition-all duration-300 shadow-lg flex items-center gap-2">
                <Edit size={18} />
                Editar Perfil
              </button>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <div
                  key={index}
                  className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
                >
                  <div className={`w-16 h-16 rounded-full bg-gradient-to-r ${stat.color} flex items-center justify-center mb-4 shadow-lg`}>
                    <Icon size={28} className="text-white" />
                  </div>
                  <p className="text-3xl font-black text-gray-900 mb-1">{stat.value}</p>
                  <p className="text-gray-500 font-medium">{stat.label}</p>
                </div>
              );
            })}
          </div>

          {/* Recent Activity */}
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-2xl font-black text-gray-900 mb-6">Actividad Reciente</h2>
            <div className="text-center py-12">
              <p className="text-gray-400 text-lg">Aún no hay actividad reciente</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
